import { Consumer } from "mediasoup-client/lib/types";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";


interface ScreenSharingComponentProps {
  consumer: Consumer | null; // The mediasoup consumer for the shared screen
  isLocal?: boolean; // Optional: to differentiate local vs remote screen share
}
const ScreenSharingComponent: React.FC<ScreenSharingComponentProps> = ({ consumer, isLocal = false }) => {
  const [stream, setStream] = useState(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const consumers = useSelector((state: RootState) => state.live.settings.consumers);
  console.log('Screensharetest', consumers)

  useEffect(() => {
    if (consumer && consumer.track) {
      const kind = consumer.track.kind;

      if (kind === "video" && videoRef.current) {
        const stream = new MediaStream([consumer.track]);
        videoRef.current.srcObject = stream;
      }

      if (kind === "audio" && audioRef.current) {
        const stream = new MediaStream([consumer.track]);
        audioRef.current.srcObject = stream;
      }
    }
    return () => {
      if (videoRef.current) videoRef.current.srcObject = null;
      if (audioRef.current) audioRef.current.srcObject = null;
    };
  }, [consumer]);


  useEffect(() => {
    if (consumers) {
      const audioConsumer: any = Object.values(consumers).find(
        (consumer: any) =>
          consumer.peerId === "trainer@vtt" && consumer.kind === "audio"
      );
      console.log('audioConsumer', audioConsumer);
      
      if (
      audioConsumer &&
      audioConsumer.track &&
      audioConsumer.track.readyState === "live"
    ) {
        const stream = new MediaStream([audioConsumer.track]);
        if(audioRef.current){
          audioRef.current.srcObject = stream;
        }
      }
    }
    return () => {
      if (audioRef.current) audioRef.current.srcObject = null;
    };
  }, [consumer]);

  // const startSharing = async () => {  
  //   try {
  //     const stream:any = await navigator.mediaDevices.getDisplayMedia({
  //       video: true,
  //     });
  //     setStream(stream);
  //   } catch (error) {
  //     console.error("Error accessing screen:", error);
  //   }
  // };

  // const stopSharing = () => {
  //   if (stream) {
  //     stream.getTracks().forEach((track) => track.stop());
  //     setStream(null);
  //   }
  // };

  // useEffect(() => {
  //    if (videoRef.current && stream) {
  //     videoRef.current.srcObject = stream;
  //   }
  //   return () => {
  //     stopSharing();
  //   };
  // }, [stream]);

  return (
    <div className="w-full h-full">
      {consumer && consumer.track ? (
        <div className="w-full h-full">
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{ width: '100%', height: '100%', backgroundColor: 'black' }}
          />
          {audioRef && (
            <audio ref={audioRef} autoPlay controls style={{display: 'none'}}/>
          )}
          {isLocal && (
            <button
              onClick={() => {
                // Assuming you have a way to access RoomClient to stop sharing
                // e.g., roomClientRef.current?.disableShare();
              }}
              className="text-white"
            >
              Stop Sharing
            </button>
          )}
        </div>
      ) : (
        <div>No screen share active</div>
      )}
    </div>
  );
};

export default ScreenSharingComponent;
